import $Message from './message';
var Message = new $Message();
export default Message;
